import { useRef } from 'react';
import PropTypes from 'prop-types';
import cn from "../../../utils/cn";
import { isEmpty } from 'lodash';
import Icon from "../Icon/Icon";
import filterChildren from "../../../utils/Children/filterChildren";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CardHeader = _ref => {
  let {
    id = '',
    style = {},
    title = '',
    children = [],
    subtitle = '',
    className = '',
    expanded = null,
    titleStyle = {},
    subtitleStyle = {},
    onExpandChange = null,
    showHeaderIcon = false,
    headerIconDetails = {},
    showExpandableButton = false
  } = _ref;
  const tableHeaderClass = cn('p-5', className);
  const tooltipClass = 'tooltip absolute top-6 w-64 p-3 rounded border border-gray-200 bg-white z-50 hidden group-hover:block';
  const newChildren = filterChildren(children);

  // Tooltip position calculations
  const headerTitleRef = useRef(null);
  const mainContentRef = useRef(null);
  let toolTipPosition;
  if (headerIconDetails.toolTipText && headerTitleRef.current && mainContentRef.current) {
    const widthDifference = mainContentRef.current.offsetWidth - (headerTitleRef.current.offsetWidth + 225);

    /** toolTipPosition(em) = target(px) / font-size(px) */
    toolTipPosition = (widthDifference < 0 ? widthDifference : -25) / 14;
  }
  return /*#__PURE__*/_jsxs("div", {
    id: id,
    className: tableHeaderClass,
    style: style,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex justify-between",
      ref: mainContentRef,
      children: [/*#__PURE__*/_jsxs("h2", {
        className: "flex justify-center items-center text-text-blue",
        style: titleStyle,
        ref: headerTitleRef,
        children: [title, showHeaderIcon ? /*#__PURE__*/_jsxs("span", {
          className: "relative ml-1",
          children: [/*#__PURE__*/_jsx(Icon, {
            color: headerIconDetails.color,
            icon: headerIconDetails.icon,
            size: headerIconDetails.size
          }), headerIconDetails.toolTipText ? /*#__PURE__*/_jsx("p", {
            className: tooltipClass,
            style: {
              left: "".concat(toolTipPosition, "em")
            },
            children: headerIconDetails.toolTipText
          }) : null]
        }) : null]
      }), showExpandableButton ? /*#__PURE__*/_jsx("div", {
        className: "my-auto",
        children: /*#__PURE__*/_jsx(Icon, {
          color: "medium-grey",
          icon: "ChevronArrow",
          direction: expanded ? 'down' : 'right',
          onClick: onExpandChange
        })
      }) : null]
    }), !isEmpty(subtitle) ? /*#__PURE__*/_jsx("div", {
      className: "text-dark-grey mt-2",
      style: subtitleStyle,
      children: subtitle
    }) : null, newChildren]
  });
};
CardHeader.propTypes = {
  /** Boolean toggle to show an icon indicator for the program title */
  showHeaderIcon: PropTypes.bool,
  /** Icon tooltip for the card header */
  headerIconDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** Can be used to render a title in Card Header. */
  title: PropTypes.node,
  /** Can be used to render a subtitle in Card Header. */
  subtitle: PropTypes.string,
  /** Override the inline-styles of the title element || Not Recommended */
  titleStyle: PropTypes.object,
  /** Override the inline-styles of the subtitle element || Not Recommended */
  subtitleStyle: PropTypes.object,
  /**  If true, this card component will include a button to expand the card. */
  showExpandableButton: PropTypes.bool,
  /**
   * Callback function fired when the expandable state of the card has changed.
   * @ignore
   */
  onExpandChange: PropTypes.func,
  /**
   * If true, this card component is expanded (uncontrolled)
   * @ignore
   */
  expanded: PropTypes.bool,
  children: PropTypes.node
};
export default CardHeader;
//# sourceMappingURL=CardHeader.js.map